/* eslint-disable i18next/no-literal-string */

export const permissions = {
    accessProfiles: {
        create: 'access-profiles:create',
        delete: 'access-profiles:delete',
        update: 'access-profiles:update',
        view: 'access-profiles:view',
    },
    approvalPolicies: {
        create: 'approval-policies:create',
        delete: 'approval-policies:delete',
        update: 'approval-policies:update',
        view: 'approval-policies:view',
    },
    escalationThresholds: {
        view: 'escalation-thresholds:view',
        edit: 'escalation-thresholds:edit',
    },
    escalationEvents: {
        view: 'escalation-events:view',
    },
    accessRequests: {
        approve: 'access-requests:approve',
        cancel: 'access-requests:cancel',
        create: 'access-requests:create',
        view: 'access-requests:view',
    },
    apiKeys: {
        create: 'api_keys:create',
        revoke: 'api_keys:revoke',
        view: 'api_keys:view',
    },
    accounts: {
        view: 'accounts:view',
        create: 'accounts:create',
        update: 'accounts:update',
        delete: 'accounts:delete',
    },
    analytics: {
        view: 'analytics:view',
    },
    auditLogs: {
        view: 'audit_logs:view',
    },
    autoAssignRules: {
        approve: 'auto-assign-rules:approve',
        create: 'auto-assign-rules:create',
        delete: 'auto-assign-rules:delete',
        impactAnalysis: 'auto-assign-rules:impact-analysis',
        submit: 'auto-assign-rules:submit',
        test: 'auto-assign-rules:test',
        update: 'auto-assign-rules:update',
        view: 'auto-assign-rules:view',
    },
    constraints: {
        view: 'constraints:view',
        create: 'constraints:create',
        edit: 'constraints:edit',
        enable: 'constraints:enable',
        review: 'constraints:review',
        trigger: 'constraints:trigger',
    },
    violations: {
        view: 'violations:view',
        ack: 'violations:ack',
    },
    jobs: {
        view: 'jobs:view',
        manage: 'jobs:manage',
        trigger: 'jobs:trigger',
    },
    cluster: {
        view: 'cluster:view',
    },
    delegations: {
        view: 'delegations:view',
        manage: 'delegations:manage',
        admin: 'delegations:admin',
    },
    certificationPolicies: {
        create: 'certification-policies:create',
        delete: 'certification-policies:delete',
        update: 'certification-policies:update',
        view: 'certification-policies:view',
    },
    certifications: {
        create: 'certifications:create',
        review: 'certifications:review',
        view: 'certifications:view',
    },
    outboundConnectors: {
        create: 'outbound-connectors:create',
        delete: 'outbound-connectors:delete',
        update: 'outbound-connectors:update',
        view: 'outbound-connectors:view',
        attributes: {
            manage: 'outbound-connectors:attributes:manage',
        },
    },
    effectiveAccess: {
        recalculate: 'effective-access:recalculate',
    },
    enforcementObjects: {
        view: 'enforcement-objects:view',
    },
    assignments: {
        revoke: 'assignments:revoke',
    },
    identities: {
        update: 'identities:update',
        view: 'identities:view',
        rehire: 'identities:rehire',
    },
    impersonation: {
        switch: 'impersonation:switch',
    },
    parties: {
        create: 'parties:create',
        update: 'parties:update',
        view: 'parties:view',
    },
    provisioning: {
        manage: 'provisioning:manage',
        view: 'provisioning:view',
    },
    resources: {
        create: 'resources:create',
        delete: 'resources:delete',
        update: 'resources:update',
        view: 'resources:view',
    },
    roleAssignments: {
        view: 'role_assignments:view',
        manage: 'role_assignments:manage',
    },
    roles: {
        create: 'roles:create',
        delete: 'roles:delete',
        update: 'roles:update',
        view: 'roles:view',
    },
    serviceAccounts: {
        create: 'service_accounts:create',
        delete: 'service_accounts:delete',
        update: 'service_accounts:update',
        view: 'service_accounts:view',
    },
    systems: {
        view: 'systems:view',
        create: 'systems:create',
        update: 'systems:update',
        delete: 'systems:delete',
    },
    time: {
        admin: 'time:admin',
    },
    types: {
        create: 'types:create',
        delete: 'types:delete',
        update: 'types:update',
        view: 'types:view',
    },
    notifications: {
        read: 'notification:read',
        admin: 'notification:admin',
        templates: 'notification:templates',
    },
    restrictionRules: {
        view: 'restriction-rules:view',
        edit: 'restriction-rules:edit',
        test: 'restriction-rules:test',
    },
    restrictionRuleRequests: {
        view: 'restriction-rule-requests:view',
        create: 'restriction-rule-requests:create',
        update: 'restriction-rule-requests:update',
        delete: 'restriction-rule-requests:delete',
        submit: 'restriction-rule-requests:submit',
        approve: 'restriction-rule-requests:approve',
        cancel: 'restriction-rule-requests:cancel',
        test: 'restriction-rule-requests:test',
    },
    reporting: {
        query: 'reporting:query',
        export: 'reporting:export',
    },
    reportingCategories: {
        manage: 'reporting-collections:manage',
    },
    functionGroups: {
        assign: 'function-groups:assign',
        create: 'function-groups:create',
        delete: 'function-groups:delete',
        update: 'function-groups:update',
        view: 'function-groups:view',
    },
    functionGroupRequests: {
        view: 'function-group-requests:view',
        create: 'function-group-requests:create',
        approve: 'function-group-requests:approve',
    },
    attributeDefinitions: {
        create: 'attribute-definitions:create',
        delete: 'attribute-definitions:delete',
        update: 'attribute-definitions:update',
        view: 'attribute-definitions:view',
        migrate: 'attribute-definitions:migrate',
        apView: 'access-profile-attribute-definitions:view',
        apCreate: 'access-profile-attribute-definitions:create',
        apUpdate: 'access-profile-attribute-definitions:update',
        apDelete: 'access-profile-attribute-definitions:delete',
        accountView: 'account-attribute-definitions:view',
        accountCreate: 'account-attribute-definitions:create',
        accountUpdate: 'account-attribute-definitions:update',
        accountDelete: 'account-attribute-definitions:delete',
        eoView: 'enforcement-object-attribute-definitions:view',
        eoCreate: 'enforcement-object-attribute-definitions:create',
        eoUpdate: 'enforcement-object-attribute-definitions:update',
        eoDelete: 'enforcement-object-attribute-definitions:delete',
    },
    partyRelationshipSchema: {
        manage: 'party-relationship-schema:manage',
        view: 'party-relationship-schema:view',
    },
    partyRelationships: {
        create: 'party-relationships:create',
        update: 'party-relationships:update',
    },
    errorLogs: {
        view: 'error-logs:view',
    },
    scriptExecuteLog: {
        view: 'script-execute-log:view',
    },
    scripts: {
        previewSql: 'scripts:preview-sql',
    },
    observability: {
        view: 'observability:view',
    },
    llmPrompts: {
        manage: 'llm-prompts:manage',
    },
    caches: {
        view: 'caches:view',
        reload: 'caches:reload',
    },
    onboarding: {
        create: 'onboarding:create',
    },
    formLayouts: {
        manage: 'form-layouts:manage',
        render: 'form-layouts:render',
    },
    inboundConnectors: {
        view: 'inbound-connectors:view',
        manage: 'inbound-connectors:manage',
        execute: 'inbound-connectors:execute',
    },
    valueLists: {
        view: 'value-lists:view',
        create: 'value-lists:create',
        update: 'value-lists:update',
        delete: 'value-lists:delete',
    },
    rehireReview: {
        manage: 'rehire-review:manage',
        listMine: 'rehire-review:list-mine',
    },
} as const
